"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _Title = _interopRequireDefault(require("../../Title"));

var _FlexTabContainer = _interopRequireDefault(require("../../FlexTabContainer"));

var _PublishPrice = _interopRequireDefault(require("../PublishPrice"));

var _PackageSwitch = _interopRequireDefault(require("../PackageSwitch"));

var _PackageCard = _interopRequireDefault(require("../PackageCard"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AccordionCommon = _interopRequireDefault(require("./AccordionCommon"));

var _Render = _interopRequireDefault(require("./Render"));

var TabPane = _FlexTabContainer["default"].TabPane;

function index(props) {
  var flexTitle = props.flexTitle,
      style = props.style,
      description = props.description,
      _a = props.configuration,
      configuration = _a === void 0 ? [] : _a,
      descriptionFooter = props.descriptionFooter;
  var isShowDescriptionFooter = descriptionFooter && descriptionFooter !== '<p></p>'; // 过滤富文本空字符

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-tab-container",
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-tab-wrap"
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: description
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-tab-main"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "publish-price-main-pc"
  }, /*#__PURE__*/_react["default"].createElement(_FlexTabContainer["default"], null, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, i) {
    var _a = item,
        title = _a.title,
        key = _a.key,
        _b = _a.list,
        list = _b === void 0 ? [] : _b;
    var compatibleArr = list;
    return /*#__PURE__*/_react["default"].createElement(TabPane, {
      key: i,
      tabIndex: key,
      title: title
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('publish-price-item', {
        noTab: (configuration === null || configuration === void 0 ? void 0 : configuration.length) <= 1
      }, {
        isShow: key !== 1
      }),
      key: i
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "publish-price-tab-main-list-wrap"
    }, compatibleArr === null || compatibleArr === void 0 ? void 0 : compatibleArr.map(function (items, index) {
      var _a = items || {},
          _b = _a.itemList,
          itemList = _b === void 0 ? [] : _b,
          _c = _a.headerList,
          headerList = _c === void 0 ? [] : _c,
          headerTitle = _a.headerTitle,
          _d = _a.packageSwitchList,
          packageSwitchList = _d === void 0 ? [] : _d,
          _e = _a.packageSwitchConfiguration,
          packageSwitchConfiguration = _e === void 0 ? [] : _e,
          _f = _a.packageCardConfiguration,
          packageCardConfiguration = _f === void 0 ? [] : _f,
          publishPriceTitle = _a.publishPriceTitle,
          packageCardTitle = _a.packageCardTitle,
          packageSwitchTitle = _a.packageSwitchTitle;

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (itemList === null || itemList === void 0 ? void 0 : itemList.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_PublishPrice["default"], {
        mainList: itemList,
        headerList: headerList,
        headerTitle: headerTitle,
        key: index,
        tab: true,
        title: publishPriceTitle
      }) : null, (packageSwitchConfiguration === null || packageSwitchConfiguration === void 0 ? void 0 : packageSwitchConfiguration.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_PackageSwitch["default"], {
        list: packageSwitchList,
        configuration: packageSwitchConfiguration,
        tab: true,
        title: packageSwitchTitle
      }) : null, (packageCardConfiguration === null || packageCardConfiguration === void 0 ? void 0 : packageCardConfiguration.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_PackageCard["default"], {
        configuration: packageCardConfiguration,
        tab: true,
        title: packageCardTitle
      }) : null);
    }))));
  })))), /*#__PURE__*/_react["default"].createElement("section", {
    className: 'publish-price-tab-main-mo'
  }, /*#__PURE__*/_react["default"].createElement(_AccordionCommon["default"] // defaultExplore={true}
  // className={'accordion-card-less'}
  , {
    // defaultExplore={true}
    // className={'accordion-card-less'}
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_Render["default"], {
        item: props
      });
    },
    configuration: configuration
  })), isShowDescriptionFooter ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('publish-price-tab-footer', {
      noTab: (configuration === null || configuration === void 0 ? void 0 : configuration.length) <= 1
    })
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "publish-price-tab-footer-desc",
    dangerouslySetInnerHTML: {
      __html: descriptionFooter || ''
    }
  })) : null));
}